import React from 'react';
import { css } from '@emotion/core';
import Typography from '@material-ui/core/Typography';
import { Button } from '@material-ui/core';
import i18next from 'i18next';

/**
 * @method ReferralNotifyCard - 邀請提示卡片
 * @param {Object}   props
 * @param {String}   props.isShowImage - 是否顯示圖片
 * @param {String}   props.imageUrl - 圖片網址
 * @param {String}   props.title - 標題
 * @param {String}   props.description - 文案
 * @param {String}   props.buttonText - 按鈕文字
 * @param {String}   props.buttonTextColor - 按鈕文字顏色
 * @param {String}   props.buttonBgColor - 按鈕背景
 * @param {String}   props.themeTextColor - 主題文字顏色
 * @param {String}   props.themeBgColor - 主題背景
 * @param {Function} props.onConfirm - 確認事件
 * @param {Function} props.onClose - 關閉事件
 * @param {Boolean}  props.disableConfirm - 禁用確認按鈕
 * @returns {JSX.Element}
 */
export default function ReferralNotifyCard({
    isShowImage,
    imageUrl,
    title,
    description,
    buttonText,
    buttonTextColor,
    buttonBgColor,
    themeBgColor,
    themeTextColor,
    onConfirm = () => {},
    onClose = () => {},
    disableConfirm
}) {
    return (
        <div css={containerStyle(themeBgColor, themeTextColor)}>
            {isShowImage && <div css={imageContainerStyle(imageUrl)}></div>}
            <div css={infoContainerStyle}>
                {title && (
                    <Typography variant="h6" css={css(titleStyle)}>
                        {title}
                    </Typography>
                )}
                {description && (
                    <Typography variant="subtitle2" css={descriptionStyle}>
                        {description}
                    </Typography>
                )}
            </div>
            <div css={buttonContainerStyle}>
                <Button
                    css={css([buttonStyle(buttonBgColor), actionButtonStyle(buttonBgColor)])}
                    onClick={onConfirm}
                    disabled={disableConfirm}
                >
                    <Typography variant="subtitle2" css={textStyle(buttonTextColor)}>
                        {buttonText}
                    </Typography>
                </Button>
                <Button css={css([buttonStyle(themeBgColor), closeButtonStyle])} onClick={onClose}>
                    <Typography variant="subtitle2" css={textStyle(themeTextColor)}>
                        {i18next.t('btn.close')}
                    </Typography>
                </Button>
            </div>
        </div>
    );
}

const actionButtonStyle = buttonBgColor => css`
    :hover {
        background-color: ${buttonBgColor};
    }
`;

const closeButtonStyle = css`
    :hover {
        background-color: transparent;
    }
`;

const containerStyle = (themeBgColor, themeTextColor) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    color: ${themeTextColor};
    background-color: ${themeBgColor};
    max-width: 320px;
    border-radius: 12px;
    width: 100%;
    box-shadow: 0px 1px 8px 0px #00000033;
    max-height: 600px;
    overflow: auto;
`;

const imageContainerStyle = imageUrl => css`
    width: 100%;
    padding-top: 66.67%;
    background-image: url(${imageUrl});
    background-size: cover;
    background-position: center;
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
`;

const infoContainerStyle = css`
    padding: 12px 16px;
    width: 100%;
`;
const buttonContainerStyle = css`
    padding: 12px 16px;
    width: 100%;
`;

const titleStyle = css`
    text-align: center;
`;

const descriptionStyle = css`
    text-align: center;
`;

const buttonStyle = bgColor => css`
    width: 100%;
    min-height: 48px;
    padding: 10px, 16px, 10px, 16px;
    border-radius: 24px;
    gap: 8px;
    background-color: ${bgColor};
`;

const textStyle = textColor => css`
    color: ${textColor};
    overflow: hidden;
    text-overflow: ellipsis;
    box-sizing: border-box;
    white-space: nowrap;
`;
